export enum Status {
    COMPLETED = 'completed',
    LOCKED = 'locked',
}

// Mirrors app-be/achievements/constants.py EVENT_TYPE.
export enum EventType {
    DAILY_STREAK = 'daily_streak',
    COMPLETE_LESSON = 'complete_lesson',
    COMPLETED_SESSION = 'complete_session',
    STUDY_TIME = 'study_time',
    PRACTICE_SKILL = 'practice_skill',
    EXP = 'exp',
}

export const EVENT_TYPE_OPTIONS: EventType[] = Object.values(EventType);

export const LIMIT_FOR_PAGINATION = 12;
export const SIZE_PAGE_OPTIONS = [
    { value: 12, label: 12 },
    { value: 24, label: 24 },
    { value: 36, label: 36 },
];